import { AppSettingEditor } from "../../helper/AppSettingditor";

const Toc = () => <AppSettingEditor title="Terms & Conditions" settingCode="AP-011" pageId={9} />;
export default Toc;